import { memo } from 'react';
import CurrentStoreRedirect from './CurrentStoreRedirect';

const HomeRedirect = () => {
    return <CurrentStoreRedirect to="" />;
};

export default memo(HomeRedirect);
